'use strict';

class CustomHarmonies {
    static maxNumberOfColorsInColorSample () {
        return 5;
    }

    static canDisplayHarmonies () {
        return false;
    }
}
export default CustomHarmonies;
